import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle, Loader2 } from 'lucide-react';

function GrandparentConfirmDialog({ 
    open, 
    onOpenChange, 
    title, 
    grandparentsList, 
    onConfirm, 
    loading, 
    errorMessage 
}) {
    const handleClose = () => {
        onOpenChange(false);
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="max-w-3xl">
                <DialogHeader>
                    <DialogTitle className="text-xl font-semibold text-primary">
                        {title || 'Confirm Grandparent Assignment'}
                    </DialogTitle>
                    <DialogDescription>
                        Please note the following distributor will be added as a Grandparent to the selected group number.
                    </DialogDescription>
                </DialogHeader>

                <div className="py-4">
                    {grandparentsList && Array.isArray(grandparentsList) && grandparentsList.length > 0 ? (
                        <div className="border rounded-lg overflow-hidden">
                            <Table>
                                <TableHeader>
                                    <TableRow className="bg-muted/30">
                                        <TableHead className="font-semibold">User Name</TableHead>
                                        <TableHead className="font-semibold">Full Name</TableHead>
                                        <TableHead className="font-semibold text-right">Commission ($)</TableHead>
                                        <TableHead className="font-semibold text-center">2nd Level</TableHead>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    {grandparentsList.map((row, index) => (
                                        <TableRow key={index}>
                                            <TableCell className="font-medium">
                                                {row.parent_UserName}
                                            </TableCell>
                                            <TableCell>
                                                {row.parent_FullName}
                                            </TableCell>
                                            <TableCell className="text-right font-mono">
                                                {row.parent_GcComm}
                                            </TableCell>
                                            <TableCell className="text-center">
                                                {row.parent_IsAllowedForGC ? (
                                                    <Badge variant="success">
                                                        Yes
                                                    </Badge>
                                                ) : (
                                                    <Badge variant="secondary">
                                                        No
                                                    </Badge>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </div>
                    ) : (
                        <div className="text-center py-8 text-muted-foreground">
                            No grandparent data available
                        </div>
                    )}

                    {errorMessage && (
                        <Alert variant="destructive" className="mt-4">
                            <AlertCircle className="h-4 w-4" />
                            <AlertDescription>{errorMessage}</AlertDescription>
                        </Alert>
                    )}
                </div>

                <DialogFooter>
                    <Button
                        type="button"
                        variant="outline"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="secondary"
                        onClick={handleConfirm}
                        disabled={loading}
                    >
                        {loading ? <><Loader2 className="h-4 w-4 animate-spin mr-2" />Processing</> : 'Proceed'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export default GrandparentConfirmDialog;

